// extracted by mini-css-extract-plugin
module.exports = {"block":"FilterIndicator_block__3hnqz","wrapper":"FilterIndicator_wrapper__1Sk3H","item":"FilterIndicator_item__185OG"};